module.exports = __webpack_public_path__ + "static/media/plus-white.61bd3745.svg";